"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/tabs/style/css");

var _tabs = _interopRequireDefault(require("antd/es/tabs"));

var _react = _interopRequireWildcard(require("react"));

var _reselect = require("reselect");

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _BadgeCollections = _interopRequireDefault(require("./BadgeCollections"));

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

var _BadgeGroups = _interopRequireDefault(require("./BadgeGroups"));

var _badges = require("../../redux/badges/badges.types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class BadgesLandingPage extends _react.Component {
  constructor() {
    super(...arguments);

    this.handleTabChange = activeKey => {
      const {
        history,
        studyId
      } = this.props;
      history.push(`/study/${studyId}/badges/${activeKey}`);
    };
  }

  componentDidMount() {
    this.props.getBadgeCollections();
    this.props.getBadgeCollectionTypes();
    this.props.getBadgeGroups();
  }

  render() {
    const {
      badgeSubpage
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "badges-landing-page"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-tab-contanier"
    }, /*#__PURE__*/_react.default.createElement(_tabs.default, {
      defaultActiveKey: badgeSubpage,
      onChange: this.handleTabChange
    }, /*#__PURE__*/_react.default.createElement(_tabs.default.TabPane, {
      tab: "Badge Collections",
      key: "badgeCollections"
    }, /*#__PURE__*/_react.default.createElement(_BadgeCollections.default, null)), /*#__PURE__*/_react.default.createElement(_tabs.default.TabPane, {
      tab: "Badge Groups",
      key: "badgeGroups"
    }, /*#__PURE__*/_react.default.createElement(_BadgeGroups.default, null)))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  studyId: selectors.getRequestedStudyId,
  badgeSubpage: selectors.getRequestedBadgeTab
});

const mapDispatchToProps = dispatch => {
  return {
    getBadgeCollections: () => dispatch(_badges.getBadgeCollectionsAsync.request()),
    getBadgeCollectionTypes: () => dispatch(_badges.getBadgeCollectionTypesAsync.request()),
    getBadgeGroups: () => dispatch(_badges.getBadgeGroupsAsync.request())
  };
};

var _default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BadgesLandingPage));

exports.default = _default;